import { render, staticRenderFns } from "./ProductStructures.vue?vue&type=template&id=634e7c3e&"
import script from "./ProductStructures.vue?vue&type=script&lang=js&"
export * from "./ProductStructures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports